import { axios } from '../../services/axios';

const uploadOperatorPlatformLogo = async ({ wholesalerId, payload, scope }) => {
    const result = await axios.post(
        `/ServiceProfile/OperatorPlatform/Wholesaler/${wholesalerId}/Logo`,
        payload,
        {
            headers: {
                'X-RequestScope': scope,
            },
        },
    );
    return result;
};

export default uploadOperatorPlatformLogo;
